import commonApi from '../api/common.api';
import { FeedType } from '../datatypes/FeedType';
import Cookies from 'universal-cookie';

const commonService = () => {
  //function to process and return list of links
  const getAndProcessRssFeed = async () => {
    const cookies = new Cookies();
    const rssFeeds = cookies.get('articles');
    let fiveItems: FeedType[] = [];
    if (!rssFeeds) {
      const response = await commonApi().getBlogXMLFeed();
      if (response.success) {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(response.data, 'application/xml');
        // Extract title, link, and description from each item
        const items = Array.from(xmlDoc.querySelectorAll('item'));
        if (items && items.length > 0) {
          const feedItems = items.map((item): FeedType => {
            const title = item.querySelector('title')?.textContent ?? '';
            const url = item.querySelector('link')?.textContent ?? '';
            return {
              title,
              url,
            };
          });
          cookies.set('articles', JSON.stringify(feedItems), {
            path: '/',
            expires: new Date(new Date().setHours(23, 59, 59, 999)),
          });

          //randomly choose 5 links
          fiveItems = feedItems.sort(() => Math.random() - 0.5).slice(0, 10);
        } else fiveItems = [];
      } else fiveItems = [];
    } else {
      fiveItems = rssFeeds.sort(() => Math.random() - 0.5).slice(0, 10);
    }
    return fiveItems;
  };

  const getSlug = (name, id) => {
    const slug = `${name} ${id * 22024}`;
    return String(slug)
      .normalize('NFKD') // split accented characters into their base characters and diacritical marks
      .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
      .trim() // trim leading or trailing whitespace
      .toLowerCase() // convert to lowercase
      .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
      .replace(/\s+/g, '-') // replace spaces with hyphens
      .replace(/-+/g, '-'); // remove consecutive hyphens;
  };

  const hasErrorConfirmPassword = (password, confirmPassword) => {
    if (confirmPassword === '') {
      return 'Confirm password is required.';
    } else if (confirmPassword !== password) {
      return 'Password mismatch.';
    } else {
      return '';
    }
  };

  return {
    getAndProcessRssFeed,
    getSlug,
    hasErrorConfirmPassword,
  };
};

export default commonService;
